import { css } from 'emotion';

import { colors } from '../../styles';

const annotationIcon = css`
  :hover {
    fill: ${colors.primary.default};

    rect {
      stroke: ${colors.primary.default};
    }

    text {
      fill: ${colors.white};
    }
  }
`;

export default {
  annotationIcon,
};
